








































































































































import { Component, Mixins } from 'vue-property-decorator';
import { Mutations, Actions } from '@/ts/store/Constants';
import { mapGetters } from 'vuex';
import UserMethods from '@/mixins/UserMethods.vue';
import InputFieldMethods from '@/mixins/InputFieldMethods.vue';
import { Validator } from 'vee-validate';

const dict = {
    custom: {
        firstname: {
            required: 'It is required to enter a first name.',
            min: 'Your first name must be longer that 2 characters.',
        },
        familyname: {
            required: 'It is required to enter a family name.',
            min: 'Your family name must be longer that 2 characters.',
        },
        email: {
            required: 'It is required to enter a email.',
            email: 'Your email must be a valid email.',
        },
        phonenumber: {
            required: 'It is required to enter a phone number.',
            numeric: 'Your phone number must be numbers, not letters.',
            min: 'Your phone number cannot be less than 8 characters.',
            max: 'Your phone number cannot be more than 8 characters.',
        },
    },
};

Validator.localize('en', dict);

@Component({
    computed: {
        ...mapGetters({
            currentUser: 'User/getUser',
            errorResponse: 'User/getProfileUpdateResponse',
            newProfileImage: 'User/getNewProfileImage',
        }),
    },
})
export default class AdminProfilePanel extends Mixins(UserMethods, InputFieldMethods) {
    constructor() {
        super();
    }

    public updateUser() {
        this.$store.commit(Mutations.SET_ADMIN_PROFILE_UPDATE_RESPONSE, null);

        this.$validator.validate().then((valid) => {
            if (valid) {
                this.$store.dispatch(Actions.UPDATE_ADMIN);
            }
        });
    }

    public readURL(file: any) {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (e: any) => {
            this.$store.commit(Mutations.SET_NEW_PROFILE_PICTURE, e.target.result);
        };
    }

    public addFloorPlan() {
        const element = (this.$refs.profilePicture as HTMLInputElement);

        if (element.files.length !== 0) {
            this.readURL(element.files[0]);
        } else {
            this.$store.commit(Mutations.SET_NEW_PROFILE_PICTURE, null);
        }

        element.type = 'text';
        element.type = 'file';
    }

    public saveNewImage() {
        const newImage = this.$store.getters['User/getNewProfileImage'];
        this.$store.dispatch(Actions.SAVE_PROFILE_IMAGE, newImage);
    }

    public resetNewImage() {
        this.$store.commit(Mutations.SET_NEW_PROFILE_PICTURE, null);
    }

    public destroyed() {
        this.resetNewImage();
    }
}
